export default "__VITE_ASSET__CDtfJ97e__"